// extracted by mini-css-extract-plugin
export default {"root":"ContactSupportLink_root__sTPyi","contactLink":"ContactSupportLink_contactLink__RrtzA"};